<template>
  <themed-modal
    name="new-project"
    title="New Project"
    size="lg"
    @closed="resetForm"
  >
    <themed-form
      :fields="formFields"
      :model-value="project"
      :errors="errors"
      layout="grid"
      :columns="3"
      @input="project = $event"
    />

    <template #footer>
      <div class="new-project-modal__footer">
        <themed-button
          variant="outline"
          @click="closeModal"
          :disabled="loading"
        >
          Close
        </themed-button>
        <themed-button
          variant="default"
          :disabled="loading"
          @click="createProject"
        >
          {{ loading ? 'Creating...' : 'Create Project' }}
        </themed-button>
      </div>
    </template>
  </themed-modal>
</template>

<script>
import ThemedModal from '../ThemedModal.vue';
import ThemedForm from '../form/ThemedForm.vue';
import ThemedButton from '../ThemedButton.vue';

export default {
  name: 'NewProjectModal',
  
  components: {
    ThemedModal,
    ThemedForm,
    ThemedButton
  },

  data() {
    return {
      project: {
        name: '',
        project_type: '',
        priority: '',
        start_date: '',
        end_date: '',
        property_type: '',
        property_usage: '',
        property_region: '',
        required_sq_ft: '',
        description: ''
      },
      errors: {},
      loading: false,
      formFields: [
        // Row 1: Name, Priority, Project Type
        {
          name: 'name',
          type: 'input',
          label: 'Name',
          required: true,
          placeholder: 'Enter project name',
          col: 1
        },
        {
          name: 'priority',
          type: 'select',
          label: 'Priority',
          required: true,
          options: [
            { value: '', label: '' },
            { value: 'Low', label: 'Low' },
            { value: 'Medium', label: 'Medium' },
            { value: 'High', label: 'High' },
            { value: 'Urgent', label: 'Urgent' }
          ],
          col: 1
        },
        {
          name: 'project_type',
          type: 'select',
          label: 'Project Type',
          required: true,
          options: [
            { value: '', label: '' },
            { value: 'Consolidation', label: 'Consolidation' },
            { value: 'Expansion', label: 'Expansion' },
            { value: 'New Location', label: 'New Location' },
            { value: 'Renewal', label: 'Renewal' }
          ],
          col: 1
        },
        // Row 2: Start Date, End Date, Property Type
        {
          name: 'start_date',
          type: 'input',
          inputType: 'date',
          label: 'Start Date',
          col: 1
        },
        {
          name: 'end_date',
          type: 'input',
          inputType: 'date',
          label: 'End Date',
          col: 1
        },
        {
          name: 'property_type',
          type: 'select',
          label: 'Property Type',
          required: true,
          options: [
            { value: '', label: '' },
            { value: 'Office', label: 'Office' },
            { value: 'Industrial', label: 'Industrial' },
            { value: 'Flex', label: 'Flex' },
            { value: 'Land', label: 'Land' },
            { value: 'Retail', label: 'Retail' }
          ],
          col: 1
        },
        // Row 3: Property Usage, Required Sq. Ft., Property Region
        {
          name: 'property_usage',
          type: 'select',
          label: 'Property Usage',
          required: true,
          options: [
            { value: '', label: '' },
            { value: 'Corporate HQ', label: 'Corporate HQ' },
            { value: 'Operations', label: 'Operations' },
            { value: 'Production', label: 'Production' },
            { value: 'Sublet', label: 'Sublet' },
            { value: 'Vacant', label: 'Vacant' }
          ],
          col: 1
        },
        {
          name: 'required_sq_ft',
          type: 'number',
          label: 'Required Sq. Ft.',
          placeholder: '0',
          col: 1
        },
        {
          name: 'property_region',
          type: 'select',
          label: 'Property Region',
          required: true,
          options: [
            { value: '', label: '' },
            { value: 'Central', label: 'Central' },
            { value: 'Mid-Atlantic', label: 'Mid-Atlantic' },
            { value: 'Northeast', label: 'Northeast' },
            { value: 'Northwest', label: 'Northwest' },
            { value: 'Outside USA', label: 'Outside USA' },
            { value: 'Southeast', label: 'Southeast' },
            { value: 'Southwest', label: 'Southwest' }
          ],
          col: 1
        },
        // Row 4: Description (full width)
        {
          name: 'description',
          type: 'textarea',
          label: 'Description',
          rows: 6,
          col: 3
        }
      ]
    };
  },

  methods: {
    closeModal() {
      this.$modal.hide('new-project');
    },

    resetForm() {
      this.project = {
        name: '',
        project_type: '',
        priority: '',
        start_date: '',
        end_date: '',
        property_type: '',
        property_usage: '',
        property_region: '',
        required_sq_ft: '',
        description: ''
      };
      this.errors = {};
      this.loading = false;
    },

    createProject() {
      this.loading = true;
      this.errors = {};

      axios.post('/projects', this.project)
        .then((response) => {
          this.$modal.hide('new-project');

          this.$notify({
            type: 'success',
            title: 'Project Created',
            text: 'Redirecting to Project...'
          });

          setTimeout(() => {
            window.location = response.data.project.view_url;
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          if (error.response && error.response.data && error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
